<template>
  <div ref="smallSwiper" class="small-swiper">
    <div class="swiper-wrapper">
      <DynamicScroller ref="scroller" :items="docPages" :min-item-size="100" :buffer="10" class="scrollbar scroller"
        key-field="pageIndex" direction="horizontal">
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem :item="item" :active="active" :data-index="index" :data-active="active">
            <div :class="{
              'is-foucs': foucsIndex == item.pageIndex,
              'is-disabled': disabled,
            }" class="swiper-slide">
              <div v-if="!item.page.isBlank" :pageindex="item.pageIndex + 1" class="small-slide-inner"
                @click="sliderTo(item.pageIndex)">
                <img :src="getUrl(item.page.small, item.pageIndex)" :style="getSamllImgStyle(item.page, item.pageIndex)"
                  class="swiper-lazy" />
              </div>
              <div v-else class="small-slide-inner" :pageindex="item.pageIndex + 1">
                <div :style="getSamllImgStyle(item.page, item.pageIndex)" class="doc-blank-item"
                  @click="sliderTo(item.pageIndex)"></div>
              </div>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading } from "element-ui";
Vue.use(Loading.directive);
// import { Popconfirm } from "element-ui";
import { mapGetters } from "vuex";
export default {
  name: "docThumbs",
  components: {
    // [Popconfirm.name]: Popconfirm,
  },
  props: {
    type: Number,
    docs: Object,
    page: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiper: undefined,
      virtual: {},
    };
  },
  computed: {
    ...mapGetters(["leftToolType"]),
    docPages() {
      return (
        this.docs?.doc?.pageinfo?.map((v, index) => {
          v.pageIndex = index;
          return v;
        }) || []
      );
    },
    foucsIndex() {
      return this.page - 1;
    },
    needScroll() {
      return [this.foucsIndex, this.docs, this.page, this.leftToolType];
    },
  },
  watch: {
    needScroll: {
      deep: true,
      immediate: true,
      handler() {
        setTimeout(() => {
          this.scrollToPage();
        }, 0);
      },
    },
  },
  methods: {
    getUrl(origin) {
      return this.docs.domain + origin;
    },
    getSamllImgStyle(data, index) {
      index == 0 && this.$emit("baseHeight", 63 + 17 * 2);
      return {
        width: "112px",
        height: "63px",
      };
    },
    getPos(index) {
      const sizes = this.$refs.scroller.$refs?.scroller.sizes;
      const items = this.$refs.scroller.vscrollData.sizes;
      let size = sizes[index - 1];
      let itemSize = items[index - 1];
      if (!itemSize) itemSize = items[0];
      return index > 0
        ? size.accumulator -
        (this.$refs.smallSwiper.offsetWidth / 2 - itemSize / 2)
        : 0;
    },
    scrollToPage() {
      this.$nextTick(() => {
        try {
          setTimeout(() => {
            this.scrollToPagePos(this.foucsIndex);
          }, 20);
        } catch (error) {
          console.log(error);
        }
      });
    },
    scrollToPagePos(foucsIndex) {
      const pos = this.getPos(foucsIndex);
      this.$refs.scroller?.$refs?.scroller?.scrollToPosition(pos);
    },
    sliderTo(index) {
      if (this.disabled) return;
      this.$emit("setPage", index + 1, this.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.small-swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  transition: 0.3s ease-in-out;
}

.small-swiper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 100%;
  padding: 17px 10px;
  box-sizing: border-box;
}

.small-swiper .swiper-slide img {
  height: 100%;
  display: block;
  width: auto;
  max-height: 112px;
  object-fit: cover;
  border: none;
  outline: none;
  user-select: none;
}

.small-swiper .swiper-slide-thumb-active,
.small-swiper .is-foucs {
  opacity: 1;
  // background-color: rgba(255, 255, 255, 0.3);
}

.small-slide-inner {
  position: relative;
  display: inline-block;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
}

.is-foucs .small-slide-inner {
  border-color: #357bda;
}

.swiper-slide.is-disabled .small-slide-inner {
  pointer-events: none;
}

.small-slide-inner::before {
  content: attr(pageindex);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  min-width: 20px;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 0 2px 0 0;
}

.is-foucs .small-slide-inner::before {
  background: #357bda;
}

.small-loadnig {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ::v-deep {
    .el-loading-spinner {
      margin-top: -10px;

      .circular {
        width: 20px;
        height: 20px;
      }
    }
  }
}

.doc-blank-item {
  position: relative;
  background-color: #fff;
}

.del-icon {
  position: absolute;
  width: 20px;
  height: 17px;
  line-height: 17px;
  right: 0;
  bottom: 0;
  font-size: 12px;
  text-align: center;
  color: #acb2bf;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 2px 0 0 0;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: #4c4e75;
}

.scrollbar:hover::-webkit-scrollbar {
  height: 8px;
}
</style>